import { render, staticRenderFns } from "./DocumentsTable.vue?vue&type=template&id=6db8d5b7&scoped=true"
import script from "./DocumentsTable.vue?vue&type=script&lang=js"
export * from "./DocumentsTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentsTable.vue?vue&type=style&index=0&id=6db8d5b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db8d5b7",
  null
  
)

export default component.exports